import { bbox } from '@turf/turf';
import { Map } from 'mapbox-gl';

import { fitMapToPlotBounds } from '../fit-map-to-plot-bounds/fit-map-to-plot-bounds';

type Params = {
  geojson?: any;
  map?: Map;
  animate?: boolean;
};

export const zoomOnFeature = (params: Params) => {
  const { animate = true } = params;
  if (params.geojson && params.map) {
    fitMapToPlotBounds(params.map, bbox(params.geojson), {
      padding: 50,
      animate,
    });
  }
};
